module.exports = __webpack_public_path__ + "static/media/bfile-cd.c0ed5f8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-cd.svg
// module id = 1010
// module chunks = 0